/* Kontaktinfos */
const telefon = '030 765 808 85'
const defaultemail = 'info@leerfahrten24.de'
const itemail = 'it@leerfahrten24.de'
const serviceemail = 'service@leerfahrten24.de'

export { telefon, defaultemail, itemail, serviceemail }
